module.exports = __webpack_public_path__ + "img/jackle-heidi.925790c2.png";